import { get } from '@/common/request';

export function GetDownloadFiles() {
  return get('download/get');
}
